/* GOB gift card page · Club style (V159, 2026-10-19). Root: #gcc[data-gcc].
   Same purchase + tracking logic as gob-gift-card-store.js (amount chips, me/friend, Shopify recipient
   properties, delivery date up to 90 days, /cart/add.js then checkout, gob-gc-track events), plus:
   gentle value roll on the card, pointer tilt (desktop), scroll reveal, phone buy bar. */
(function () {
  var root = document.querySelector('#gcc[data-gcc]');
  if (!root) return;
  var form = root.querySelector('form.gcc-form');
  if (!form) return;
  root.classList.add('js');

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return root.querySelectorAll(s); };
  var ADD = root.getAttribute('data-add') || '/cart/add.js';
  var CART = root.getAttribute('data-cart') || '/checkout';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var who = 'me', when = 'now';
  var vid = form.querySelector('input[name="id"]');
  var sendOn = form.querySelector('[data-sendon]');
  form.querySelector('[data-offset]').value = String(new Date().getTimezoneOffset());

  /* ---- tracking (same endpoint and events as the Store page) ---- */
  var TRACK = 'https://ayflivmnbjberbmvimtg.supabase.co/functions/v1/gob-gc-track';
  var PV = Math.random().toString(36).slice(2, 12) + Date.now().toString(36).slice(-4);
  var MKT = root.getAttribute('data-card-currency') || '';
  var sent = {};
  function track(ev, extra, key) {
    if (window.Shopify && window.Shopify.designMode) return;
    var k = ev + '|' + (key || '');
    if (sent[k]) return; sent[k] = 1;
    try {
      var o = { pv: PV, ev: ev, mkt: MKT };
      if (extra) for (var p in extra) o[p] = extra[p];
      var body = JSON.stringify(o);
      if (navigator.sendBeacon && navigator.sendBeacon(TRACK, new Blob([body], { type: 'text/plain' }))) return;
      fetch(TRACK, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) {}
  }

  /* ---- helpers ---- */
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function fmt(s) { return new Date(s + 'T12:00:00').toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sup(s) { var m = String(s).match(/^(.*\d)([.,])(\d{2})(\D*)$/); return m ? esc(m[1]) + '<sup>' + m[3] + '</sup>' + esc(m[4]) : esc(s); }
  function txt(sel, t) { $$(sel).forEach(function (e) { if (e.textContent !== t) e.textContent = t; }); }

  /* ---- delivery date ---- */
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var minD = new Date(today); minD.setDate(minD.getDate() + 1);
  var maxD = new Date(today); maxD.setDate(maxD.getDate() + 90);
  var dateIn = $('[data-date]'), pick = $('.pick'), pickT = $('.pick-t');
  dateIn.min = iso(minD); dateIn.max = iso(maxD);
  dateIn.addEventListener('click', function () { try { dateIn.showPicker && dateIn.showPicker(); } catch (e) {} });
  var special = {};
  [['xmas-eve', 24], ['xmas', 25]].forEach(function (p) {
    var y = today.getFullYear(), d = new Date(y, 11, p[1]);
    if (d < minD) d = new Date(y + 1, 11, p[1]);
    var b = root.querySelector('[data-when="' + p[0] + '"]');
    if (b && d >= minD && d <= maxD) { special[p[0]] = iso(d); b.hidden = false; }
  });

  /* ---- card value: gentle roll ---- */
  var valBox = $('.gc .roll'), symEl = $('.js-sym');
  function setValue(sym, num) {
    if (symEl && symEl.textContent !== sym) symEl.textContent = sym;
    var cur = valBox && valBox.querySelector('.js-val');
    if (!cur || cur.textContent === num) return;
    if (reduce) { cur.textContent = num; return; }
    var nx = document.createElement('span');
    nx.className = 'js-val in'; nx.textContent = num;
    cur.classList.remove('js-val'); cur.classList.add('out');
    cur.addEventListener('animationend', function () {
      if (cur.parentNode) cur.parentNode.removeChild(cur);
      valBox.appendChild(nx);
      nx.addEventListener('animationend', function () { nx.classList.remove('in'); }, { once: true });
    }, { once: true });
    valBox.querySelectorAll('.out').forEach(function (o) { if (o !== cur && o.parentNode) o.parentNode.removeChild(o); });
  }

  function current() { return root.querySelector('.amtg [aria-pressed=true]'); }

  function sync() {
    var b = current(), label = b ? b.dataset.label : '', price = b ? b.dataset.price : '';
    var m = label.match(/^(\D*)(.*)$/) || ['', '', label];
    var toIn = $('#gcc-to').value.trim(), frIn = $('#gcc-from').value.trim(), msg = $('#gcc-msg').value;
    var to = toIn || 'Tom', fr = frIn || 'Anna', me = who === 'me';
    var dateTxt = when === 'now' ? '' : fmt(sendOn.value);
    setValue(m[1], m[2]);
    $$('.js-price').forEach(function (e) { e.innerHTML = sup(price); });
    txt('.js-for', me || !toIn ? 'For you' : 'For ' + toIn);
    txt('.js-to', me ? 'You' : to);
    txt('.js-subj', me ? 'Your ' + label + ' Game of Bricks gift card' : fr + ' sent you a ' + label + ' Game of Bricks gift card');
    txt('.js-arr', me || when === 'now' ? 'right after checkout' : dateTxt);
    txt('.js-head', me ? 'Your gift card is ready' : "You've got a gift!");
    var note = $('.js-note');
    note.hidden = me;
    note.textContent = msg || 'Your message will appear here.';
    note.classList.toggle('ph', !msg);
    var fine = me ? 'The code is emailed to you right after checkout' : (when === 'now' ? 'Arrives in their inbox right after checkout' : 'Arrives in their inbox on ' + dateTxt);
    txt('.js-fine', fine);
    txt('.js-barlabel', label);
    txt('.js-barfine', me ? 'Emailed to you after checkout' : (when === 'now' ? 'Sent to ' + to + ' after checkout' : 'Sent to ' + to + ' on ' + dateTxt));
    txt('[data-cnt]', String(msg.length));
  }

  $$('.amtg button').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.amtg button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      vid.value = b.dataset.vid;
      sync();
      track('amount', { amt: b.dataset.label }, b.dataset.label);
    });
  });

  $$('[data-who]').forEach(function (b) {
    b.addEventListener('click', function () {
      who = b.dataset.who;
      if (who === 'them') track('friend');
      $$('[data-who]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var f = $('.recip');
      f.hidden = who === 'me'; f.disabled = who === 'me';
      hideErr(); sync();
      if (who === 'them' && window.matchMedia('(min-width: 861px)').matches) { try { $('#gcc-to').focus({ preventScroll: true }); } catch (e) {} }
    });
  });

  function setWhen(w, val) {
    when = w;
    $$('[data-when]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.when === w)); });
    if (w === 'now') { sendOn.value = ''; sendOn.disabled = true; } else { sendOn.value = val; sendOn.disabled = false; }
    pick.classList.toggle('on', w === 'date');
    pickT.textContent = w === 'date' ? fmt(val) : 'Other date';
    sync();
  }
  $$('[data-when]').forEach(function (b) {
    b.addEventListener('click', function () {
      var w = b.dataset.when;
      if (w === 'now') setWhen('now'); else setWhen(w, special[w]);
      dateIn.value = '';
    });
  });
  dateIn.addEventListener('change', function () {
    if (!dateIn.value) return setWhen('now');
    if (dateIn.value < dateIn.min || dateIn.value > dateIn.max) {
      showErr('Pick a date between tomorrow and ' + fmt(dateIn.max) + '.');
      dateIn.value = ''; return setWhen('now');
    }
    hideErr(); setWhen('date', dateIn.value);
  });
  ['#gcc-to', '#gcc-from', '#gcc-msg'].forEach(function (s) { $(s).addEventListener('input', sync); });
  $('#gcc-em').addEventListener('input', function () { this.removeAttribute('aria-invalid'); hideErr(); });

  var err = $('.err');
  function showErr(t) { err.textContent = t; err.classList.add('on'); }
  function hideErr() { err.classList.remove('on'); }

  form.addEventListener('submit', function (e) {
    e.preventDefault(); hideErr();
    if (who === 'them') {
      var em = $('#gcc-em'), ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim());
      if (!ok) {
        em.setAttribute('aria-invalid', 'true');
        em.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        try { em.focus({ preventScroll: true }); } catch (x) {}
        return showErr('Add their email address so we know where to send it.');
      }
    }
    var go = form.querySelector('.atc');
    go.disabled = true;
    var tk = { amt: (current() || { dataset: {} }).dataset.label || '', who: who === 'me' ? 'me' : 'friend' };
    track('buy', tk);
    fetch(ADD, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var d = res.d || {}, t = d.description || d.message || 'Something went wrong. Please try again.';
          if (t && typeof t === 'object') t = Object.keys(t).map(function (k) { return [].concat(t[k]).join(' '); }).join(' ');
          go.disabled = false;
          return showErr(t);
        }
        track('added', tk);
        if (window.GOB_GC_NO_REDIRECT) { go.disabled = false; window.GOB_GC_WENT = CART; return; }
        window.location.href = CART;
      })
      .catch(function () { go.disabled = false; showErr('Something went wrong. Please try again.'); });
  });

  /* ---- card tilt (fine pointers only) ---- */
  var cw = $('[data-tilt]'), gc = cw && cw.querySelector('.gc');
  if (cw && gc && !reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var raf = 0;
    cw.addEventListener('pointermove', function (e) {
      var r = cw.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { gc.style.transform = 'rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg)'; });
    });
    cw.addEventListener('pointerleave', function () { cancelAnimationFrame(raf); gc.style.transform = ''; });
  }

  /* ---- scroll reveal ---- */
  var rv = $$('.rv');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('on'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('on'); });
  }

  /* ---- "Choose an amount" button in the final band ---- */
  $$('[data-top]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = $('#gcc-amt-l');
      if (t) t.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---- phone buy bar: visible while the buy button is off screen, hidden near the footer ---- */
  var bar = $('[data-bar]'), atc = form.querySelector('.atc'), fin = $('.fin');
  if (bar && 'IntersectionObserver' in window) {
    var atcVisible = true, finVisible = false, passed = false;
    var setBar = function () {
      var on = passed && !atcVisible && !finVisible;
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelector('[data-barbuy]').tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { atcVisible = en.isIntersecting; if (!en.isIntersecting && en.boundingClientRect.top < 0) passed = true; if (en.isIntersecting) passed = false; });
      setBar();
    }).observe(atc);
    if (fin) new IntersectionObserver(function (es) { es.forEach(function (en) { finVisible = en.isIntersecting; }); setBar(); }).observe(fin);
    bar.querySelector('[data-barbuy]').addEventListener('click', function () {
      if (who === 'me') { if (form.requestSubmit) form.requestSubmit(); else atc.click(); }
      else { $('#gcc-amt-l').scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); }
    });
  }

  sync();
  track('view');
})();
